export const defaultErc20Decimals = 0
